import React from 'react';
import { Group, useBreakpoint } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import { Title, SeeMore } from './';

const carouselHeaderStyles = css({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 'xl',
    flexDirection: 'column',
    alignItems: 'left',

    md: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});

export const Header = () => {
    const isMd = useBreakpoint('md');

    return (
        <Group
            className={carouselHeaderStyles}
            alignItems={isMd ? 'flex-start' : 'space-between'}
            direction={isMd ? 'vertical' : 'horizontal'}
            gap={isMd ? 'xs' : 'xl'}
        >
            <Group.Item>
                <Title />
            </Group.Item>
            <Group.Item>
                <SeeMore />
            </Group.Item>
        </Group>
    );
};
